import apiUseCases from "@src/cloud-connect/api";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import { i18n } from "@src/i18n/i18n";
import store from "@src/reducers/store";

export const autoMatchBlueprintUseCase = async () => {
  try {
    const state = store.getState();
    const source_id = state.yourSlice.connectionView?.source?.source_id;
    const language = state.yourSlice.language;
    const namespace = state.yourSlice.authContext?.customerNamespace;

    const texts = {
      blueprintAutomatchUnexpectedError: i18n(
        "modules.snackbarNotifications.blueprintAutomatchUnexpectedError",
        language,
      ),
    };

    if (!source_id || !namespace) {
      errorSnackbar(texts.blueprintAutomatchUnexpectedError);
      return [];
    }

    const response = await apiUseCases.autoMatchBlueprint(source_id, namespace);

    if (response.status === 200) {
      return response.body;
    } else if (response.status === 404) {
      errorSnackbar(response.body.message);
      return [];
    } else {
      errorSnackbar(texts.blueprintAutomatchUnexpectedError);
      return [];
    }
  } catch (error) {
    const language = store.getState().yourSlice.language;
    const texts = {
      blueprintAutomatchUnexpectedError: i18n(
        "modules.snackbarNotifications.blueprintAutomatchUnexpectedError",
        language,
      ),
    };

    const parsedError = parseAxiosApiError(
      error,
      texts.blueprintAutomatchUnexpectedError,
    );
    errorSnackbar(
      parsedError.message || texts.blueprintAutomatchUnexpectedError,
    );
    return [];
  }
};
